export type Tutorial = {
  title: string
  videoId: string
  /**
   * Not an exact match. For example, /brokerage will match /brokerage/leads, /brokerage/listings, and /brokerage/pipeline.
   **/
  showOnRoute?: string
}

/**
 * First element is a featured video in the Tutorials page that takes up an entire row.
 */
export const TUTORIALS: Tutorial[] = [
  {
    title: 'Overview',
    videoId: 'cyzzf2jfu5',
  },
  {
    title: 'Adding Forms',
    videoId: 'vtir1hzhsy',
    showOnRoute: '/forms',
  },
  {
    title: 'Assignments',
    videoId: 'hifh6ccbvd',
    showOnRoute: '/calendars/Assignments',
  },
  {
    title: 'Creating a New Contact',
    videoId: '476v69apx9',
    showOnRoute: '/connections',
  },
  {
    title: 'Creating a New Listing',
    videoId: '4vraicpdt5',
    showOnRoute: '/brokerage/listings',
  },
  {
    title: 'Creating a Post and Tagging Team Members',
    videoId: '9sjvy0f3z7',
    showOnRoute: '/home',
  },
  {
    title: 'Creating Leads',
    videoId: 'ceqjw8m9e1',
    showOnRoute: '/brokerage/leads',
  },
  {
    title: 'Development',
    videoId: '2uoxunqjpp',
    showOnRoute: '/development',
  },
  {
    title: 'Pipeline',
    videoId: 'e6s5qo4rx4',
    showOnRoute: '/brokerage/pipeline',
  },
  {
    title: 'Uploading and Sending Files',
    videoId: 'j35qbouw10',
    showOnRoute: '/properties/property',
  }
]
